import { _, Bridge, UtilCommon } from '@iskytrip/sdk'
import {
	QueryProductsByCouponId,
	GetCouponUseJumpUrl,
	GetEquityToUseJumpUrl,
	GetCouponJumpUrl,
	GainEquity,
} from '@src/api'

export class UtilCoupon {
	static api = {
		getCouponUseJumpUrlModel: new GetCouponUseJumpUrl(),
		queryProductsByCouponIdModel: new QueryProductsByCouponId(),
		getEquityToUseJumpUrl: new GetEquityToUseJumpUrl(),
		getCouponJumpUrl: new GetCouponJumpUrl(),
		gainEquity: new GainEquity(), //领取权益和券
	}

	/**
	 * @desc 优惠券去使用
	 */
	static toUse({ couponId, relationId }, context) {
		context.dataLoading && context.dataLoading(true)
		Bridge.appGetVersion((appVersion) => {
			if (_.isHasValue(appVersion)) {
				const compareVersionResult = UtilCommon.compareVersion(appVersion, '1.4.0')
				// 当前app版本 < 1.4.0
				if (compareVersionResult === -1) {
					UtilCoupon.api.queryProductsByCouponIdModel
						.setParams({ couponId, relationId })
						.execute()
						.then(function(result) {
							context.dataLoading(false)
							console.log(JSON.stringify(result))
							if (result.resultCode === '0') {
								let resultData = result.resultData
								if (resultData.length === 1) {
									let model = resultData[0]
									let url = model.markData || ''
									context.go(url)
								} else if (resultData.length > 1) {
									context.jump('goodsList', {
										couponId,
										orderNo: '',
										isCoupons: '1',
									})
								} else {
									Bridge.appToast('暂不能使用该券，可联系客服进行反馈')
								}
							}
						})
						.catch(function(error) {
							context.dataLoading(false)
							console.error(error)
						})
				} else {
					// 新的
					UtilCoupon.api.getCouponUseJumpUrlModel
						.setParams({ couponId, relationId })
						.execute()
						.then(({ jumpUrl }) => context.commonGoURL(jumpUrl))
						.finally(() => {
							context.dataLoading(false)
						})
				}
			}
		})
	}

	// 领券中心优惠券去使用
	static centerToUseCoupon({ couponId, relationId }, context) {
		// context.dataLoading && context.dataLoading(true)
		UtilCoupon.api.getCouponJumpUrl
			.setParams({ couponId, relationId })
			.execute()
			.then(function(result) {
				if (+result.resultCode === 0) {
					let resultData = result.resultData || {}
					let jumpUrl = resultData.jumpUrl || ''
					// 聚合跳转
					context.commonGoURL(jumpUrl)
				}
			})
			.finally(() => {
				console.log('finally')
				// context.dataLoading(false)
			})
	}

	// 权益券去使用
	static toUseEquity({ equityId, userEquityId }, context) {
		UtilCoupon.api.getEquityToUseJumpUrl
			.setParams({ equityId, userEquityId })
			.execute()
			.then(function(result) {
				console.log(JSON.stringify(result))
				if (result.resultCode === '0') {
					let resultData = result.resultData || {}
					let jumpUrl = resultData.jumpUrl || ''
					context.commonGoURL(jumpUrl)
				}
			})
			.finally(() => {
				context.dataLoading(false)
			})
	}

	//领取优惠券或者权益券
	static gainEquity(
		{ equityType, memberEquityId, relationId, userMemberId, userEquitiesId },
		completion,
		context,
	) {
		context.dataLoading && context.dataLoading(true)
		UtilCoupon.api.gainEquity
			.setParams({ equityType, memberEquityId, relationId, userMemberId, userEquitiesId })
			.execute()
			.then((result) => {
				completion && completion(result)
			})
			.catch(function(error) {
				context.dataLoading(false)
				console.error(error)
			})
			.finally(() => {
				context.dataLoading(false)
			})
	}
}
